import Image from "next/image";

type QueueBrandPanelProps = {
  image: string;
  backgroundColor: string;
  title: string;
  color: string;
};

export function QueueBrandPanel({ image, backgroundColor, color, title }: QueueBrandPanelProps) {
  return (
    <div
      className="flex h-[104px] flex-col items-center justify-center rounded-[7px] px-[18px]"
      style={{ backgroundColor }}
    >
      <div className="relative h-[60px] w-full">
        <Image src={image} alt={title} fill className="object-contain object-center" unoptimized />
      </div>
      <p className="mt-[10px] text-center text-[15px] font-black uppercase leading-none text-[#2033ef]" style={{ color }}>{title}</p>
    </div>
  );
}
